import * as React from 'react'

import { Plus, Trash2 } from 'lucide-react'

import ListSelectionToolbar from '~/client/src/desktop/tables/ListSelectionToolbar'
import type { UseTableListResult } from '~/client/src/desktop/tables/useTableList'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import SmartFormImportStore from '../components/SmartFormImport/SmartFormImport.store'
import SmartFormImportPopover from '../components/SmartFormImport/SmartFormImportPopover/SmartFormImportPopover'
import type { IFormTypeRow } from '../types'

interface ISelectionToolbarProps {
  list: UseTableListResult<IFormTypeRow>
  canDelete: boolean
  onDelete: () => void
  smartFormImportStore: SmartFormImportStore
  onAddNewFormClick: () => void
}

export default function SelectionToolbar({
  list,
  canDelete,
  onDelete,
  smartFormImportStore,
  onAddNewFormClick,
}: ISelectionToolbarProps): React.ReactElement {
  const t = Localization.translator

  const deleteButton = (disabled: boolean) => (
    <Button variant="destructive-ghost" onClick={onDelete} disabled={disabled}>
      <Trash2 aria-hidden="true" />
      {t.delete}
    </Button>
  )

  return (
    <ListSelectionToolbar
      list={list}
      countLabel={t.xWorkflows(list.model.filteredCount)}
      selectionActions={
        canDelete ? (
          deleteButton(false)
        ) : (
          <Tooltip>
            <TooltipTrigger
              render={
                <span className="tw:inline-flex">{deleteButton(true)}</span>
              }
            />
            <TooltipContent>{t.deletionOfDefaultForms}</TooltipContent>
          </Tooltip>
        )
      }
    >
      <SmartFormImportPopover store={smartFormImportStore} />
      <Button size="lg" onClick={onAddNewFormClick}>
        <Plus aria-hidden="true" />
        {t.newFormType}
      </Button>
    </ListSelectionToolbar>
  )
}
